 
<template>
    <div class="chart-block">
        <h3>
               <a :href="url" target="_blank"> {{chartName}}</a>
             <span>{{updated}}</span></h3>
        <div id="chart_nesm" class="chart-box">
        </div>
    </div>
</template>
<script>
    import echarts from 'echarts'
    import {strToYeayAndMonth } from '@/plugins/DateTimeFormater.js';
    import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
    export default {
        props: {
            chartName: {
                type: String,
                default: '新能源上市车型统计'
            }
        },
        data() {
            return {
                url:"#",
                chartOption: {},
                myChart:null,
                chartId:'new_models_start_market',
                updated:'',
            }
        },
        mounted() {
        
             
            this.chartOption = {
                 color:['#4ebdea','#a7def3','#327ed4','#5aa0b3','#3b5b81','##f4eede','#bb3021'],
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c}款 ({d}%)',
                     triggerOn:"mousemove",   
                       
                },
                legend: {                
                    right: 30,
                    data: ['增程式电动', '插电式混合动力', '油电混合动力', '纯电动'] //, 'MCE1', 'MCE2', 'MCE2-1', 'MCE2-2', 'MCE3', 'NM','NP'
                },
                series: [{
                        name: '新能源类型',
                        type: 'pie',
                        selectedMode: 'single',
                        radius: [0, '30%'],
                        label: {
                            position: 'inner',
                            show:false,
                        },
                        labelLine: {
                            show: false
                        },
                        data: []
                    },
                    {
                        name: '工改模类型',
                        type: 'pie',
                        radius: ['40%', '55%'],
                                           
                        data: [ ]
                    }
                ]
            };
            this.getChartList({handle:this.updateChart});
            //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
            window.addEventListener('resize', function() {
              this.myChart  &&  this.myChart.resize()
            });
        },
        methods: {
            ...mapActions("home", ["queryChartConfigs", "queryChartUpdate","getChartList"]),
             updateChart() {
                this.myChart = echarts.init(document.getElementById("chart_nesm"));
                var info = this.getChartByName(this.chartId);
                this.url = info.url;
                var jsonArr = eval(info.jsonData);
                this.chartOption.series[0].data = jsonArr[0];
 
                // var newArr = [];
                // var total = 0;
                // for(var item of jsonArr[1])
                // {
                //     if(item.name.substr(0,2)=='改款')
                //     {
                //         total += item.value;
                //     }else{
                //        newArr.push(item); 
                //     }
                // }
               // newArr.push({"name":"改款","value":total});

                 this.chartOption.series[1].data = jsonArr[1];
                this.myChart.setOption(this.chartOption);
                window.addEventListener("resize", function() {
                    this.myChart && this.myChart.resize();
                });
         
      this.updated = `${strToYeayAndMonth(info.lastUpdated)}更新`;
        
       
    }
        },
          computed: {
             ...mapGetters("home", {chartList: "chartList",getChartByName: "getChartByName"}),
             },
        watch: {},
        created() {}
    }
</script>
 